import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { stepControlsContextObj } from '@cian/frontend-request-form-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSendFeedbackSucceed } from '../../selectors/sendFeedback';
import { MessageSentBodyContainer } from './containers/MessageSentBodyContainer';
import { ModerationIssuesBodyContainer } from './containers/ModerationIssuesBodyContainer';
import { DefaultBodyContainer } from './containers/DefaultBodyContainer';
import { EStepCodes } from '../../types/requestForm';
import { jsx as _jsx } from "react/jsx-runtime";
export var QuestionBodyContainer = function QuestionBodyContainer(props) {
  var isSendFeedbackSucceed = useSelector(selectSendFeedbackSucceed);
  var _React$useContext = React.useContext(stepControlsContextObj),
    currentStep = _React$useContext.currentStep;
  if (isSendFeedbackSucceed) {
    return /*#__PURE__*/_jsx(MessageSentBodyContainer, {});
  }
  if (currentStep.code === EStepCodes.ModerationIssues) {
    return /*#__PURE__*/_jsx(ModerationIssuesBodyContainer, _objectSpread({}, props));
  }
  return /*#__PURE__*/_jsx(DefaultBodyContainer, _objectSpread({}, props));
};